
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPinGoogle as ObiPinGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pin-google.js';
 
 
 

 
 export const ObiPinGoogle = createComponent({
   react: React,
   tagName: 'obi-pin-google',
   elementClass: ObiPinGoogleElement,
   events: {
     
   }
  });
 
 